import React from 'react';

import COLORS from 'src/lib/colors';
import {Dims} from 'src/lib/commonTypes';

import {XScale} from './D3Axis';
import {useTranslations} from './TranslationsContext';

type Props = {
  x: XScale;
  dateRange: [Date, Date];
  graphDims: Dims;
};

export function NowLine({x, dateRange, graphDims}: Props) {
  const {t} = useTranslations();
  const now = new Date();

  // now is not displayed
  if (now < dateRange[0] || now > dateRange[1]) {
    return null;
  }

  return (
    <g className="sharp">
      <text
        fontSize={10}
        x={x(now) + 4}
        y={8}
        textAnchor="left"
        fill={COLORS.AXIS}
        fillOpacity={0.3}
      >
        {t('now')}
      </text>
      <line
        x1={x(now)}
        x2={x(now)}
        y1={0}
        y2={graphDims[1]}
        stroke={COLORS.AXIS}
        strokeWidth={3}
        strokeOpacity={0.2}
      />
    </g>
  );
}
